import {connect} from 'react-redux';
import Component from './StreamPast';
import {STREAM_EVENT_PAST} from '../../../../api/stream/CustomStreamEvent';
import {setHeaderTitle} from '../../../../actions/layout';
import {listStateFromCRUD, listDispatchFromCrud} from '../../../../selectors/crud';
import {getCurrentClubId} from '../../../../selectors/club-settings';

import {
  STREAM_ROUTER_EDIT,
  STREAM_ROUTER_NEW,
  VOD_ROUTER_NEW,
  STREAM_ROUTER_PAST,
  STREAM_ROUTER_UPCOMMING,
  STREAM_ROUTER_VOD,
  VOD_ROUTER_EDIT
} from '../constants';
import {push} from 'react-router-redux/lib/actions';
import {streamAction} from '../../../../actions/stream/customStream';

export default connect(
  (state) => ({
    ...listStateFromCRUD(state.customStream),
    filter: {
      streamType: STREAM_EVENT_PAST,
      club_id: getCurrentClubId(state)
    }
  }),
  (dispatch) => {
    return {
      updateHeaderTitle: (title) => dispatch(setHeaderTitle(title)),
      ...listDispatchFromCrud(dispatch, streamAction),
      edit: (id) => dispatch(push(STREAM_ROUTER_EDIT.replace(':id', id))),
      editVoD: (id) => dispatch(push(VOD_ROUTER_EDIT.replace(':id', id))),
      goToUpcomming: () => dispatch(push(STREAM_ROUTER_UPCOMMING)),
      goToPast: () => dispatch(push(STREAM_ROUTER_PAST)),
      gotoVoD: () => dispatch(push(STREAM_ROUTER_VOD)),
      addStream: () => dispatch(push(STREAM_ROUTER_NEW)),
      addVoD: () => dispatch(push(VOD_ROUTER_NEW))
    }
  }
)(Component);



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/StreamPast/index.js